$(function() {
	//tab
   $(document).on('click', '.product__top--right--tabs .tabs__nav li', function() {
		var index = $('.product__top--right--tabs .tabs__nav li').index(this),
			index2;
	   tabID = index;
	   if(index === 0) {
		   index2 = 1;
	   } else {
		   index2 = 0;
	   }
		setTab(index,index2);
		return false;
	});
	function setTab(num,num2){
		var elm = $('.tabs__contents--text').eq(num),
			elm2 = $('.tabs__contents--text').eq(num2);
		$('.product__top--right--tabs .tabs__nav li').removeClass('selected');
		$('.product__top--right--tabs .tabs__nav li').eq(num).addClass('selected');
		TweenMax.to('.tabs__contents', .4, { opacity : 0, ease: Power3.easeInOut, onComplete: function(){
			elm.show();
			elm2.hide();
			TweenMax.fromTo('.tabs__contents', .4, { opacity : 0 }, { opacity : 1, ease: Power3.easeInOut, onComplete: function(){
				
			}});
		}});
		
	}
	
	//slick
	var $slider = $('.product__top--left--img').slick({
		infinite: true, //スライドのループ有効化
		arrows: true, //矢印非表示
		draggable: true, //ドラッグ操作の無効化
		autoplay: false,
		dots: true,
	});
});